import login from './Login/login';
import menu from './Menu/menu';
import competition from './competition';
import paper from './paper';
import teachBusiness from './teachBusiness';
import CollectStore from './collect';
import RegistrationStore from './registration';
import template from './template';
import declaration from './declaration';
import signUpStore from './signUpStore';
import order from './order';
import refund from './refund';
import mall from './Mall';
import receipt from './receipt';
import evaluation from './evaluation';
import homeSearch from './homeSearch';
import comment from './comment';
import trainingPlan from './trainingPlan';
import global from './global';
import face from './faceAndRealName';
import templatePublic from './templatePublic';
import templateLearCard from './templateLearCard';
import teacher from './teacher';
import project from './project';
import improveInformation from './improveInformation';
import forceNotice from './forceNotice';

const store = {
    global,
    login,
    menu,
    competition,
    paper,
    teachBusiness,
    CollectStore,
    RegistrationStore,
    template,
    declaration,
    signUpStore,
    order,
    refund,
    mall,
    receipt,
    evaluation,
    homeSearch,
    comment,
    face,
    trainingPlan,
    templatePublic,
    teacher,
    forceNotice,
    project,
    templateLearCard,
    improveInformation
};

export default store;
